import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as courseActions from '../../actions/courseActions';
import {bindActionCreators} from 'redux';
import moment from 'moment';


class CoursesViewContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.actions.getCourse(this.props.match.params.id)
    }

    render() {
        let {course} = this.props;

        return (
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="card-block">
                            <h4 className="mt-0 m-b-15 header-title">Kursusinformation</h4>

                            <table className="table table-striped">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Statistik</th>
                                    <th>Kontaktperson</th>
                                    <th>Offentliggøres</th>
                                    <th>Udløber</th>
                                    <th>Kategorier</th>
                                    <th>Undervisningsregion</th>
                                    <th>Pris</th>
                                    <th>Yderligere Information</th>
                                    <th>Tilmelding</th>
                                </tr>

                                </thead>
                                <tbody>
                                <tr>
                                    <td>{course.id}</td>
                                    <td>{course.isStatistic.toString()}</td>
                                    <td>{course.contactPerson.name}</td>
                                    <td>{moment.unix(course.startDate).format('DD-MM-YYYY')}</td>
                                    <td>{moment.unix(course.endDate).format('DD-MM-YYYY')}</td>
                                    <td>
                                        {
                                            course.categories.map(category => {
                                                return <span key={`course${course.id}-category${category.id}`} className="badge badge-default font-weight-normal">{category.title}</span>
                                            })
                                        }
                                    </td>
                                    <td>{course.location ? course.location.region : null}</td>
                                    <td>{`${course.price} ${course.currency.name} ${course.priceType.name}`}</td>
                                    <td>{course.additionalInformation}</td>
                                    <td>{course.registrationLink}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CoursesViewContainer.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    const DATE_PATTERN = 'DD-MM-YYYY';

    let course = {};

    if (Object.keys(state.course).length !== 0) {
        course = state.course;
    } else {
        course = {
            contactPerson: {name: ''},
            categories: [],
            region: {name: ''},
            price: 0,
            currency: {name: ''},
            priceType: {name: ''},
            endDate: moment().format(DATE_PATTERN),
            startDate: moment().format(DATE_PATTERN),
            additionalInformation: "",
            registrationLink: "",
            isStatistic: true,
        };
    }

    return {
        course: course,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(courseActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CoursesViewContainer);


// WEBPACK FOOTER //
// ./web/src/components/venues-and-courses/CourseViewContainer.jsx